import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { scType } from './Function';
import { Row,Col,Card,Placeholder,Nav, Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
const SocietyClubsList = ({pageData}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(true);
    const [Clubs,setClubs]=useState([]);
    useEffect(()=>
    {
        const getClubsByType = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"clubs/byTypeAll/"+scType(pageData.sp_id));
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sc_id + "/scPhoto")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sc_id + "/scPhotoHi")
                                .then(upph => upph.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp,upph]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upph
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].scPhoto = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].scPhotoHi = (el.upph.length > 0) ? global.config.uploadPath + el.upph[0].up_fname + el.upph[0].up_ext : '';                            
                        });
                        setLoading(false);
                        setClubs(result);
                    }).catch(error => {
                        console.error('ClubsByType File :', error);
                    });
                }
                else
                {
                    setLoading(false);
                    setClubs([]);
                }
                if( global.config.IsPrint === true ) { console.info('ClubsByType : Result',result); }
              
            } catch (error) 
            {
                console.error('ClubsByType : Error', error.message);
                setLoading(false);
            }
        };
        getClubsByType();
    },[pageData])
    return (
        <Card className='text-center bg-secondary-subtle'>
            <Card.Header className='fs-3'>{appLanguage === 'hi' ? pageData.sp_name_hi || pageData.sp_name : pageData.sp_name}</Card.Header>
            <Card.Body>
            {isLoading ? (
                <Row className='row-cols-3 g-3'>
                {[...Array(10)].map((_,index)=>(
                    <Col md={3} key={index}>
                        <Card className='text-bg-info bg-info-subtle important-background shadow h-100' data-aos="flip-up" data-aos-duration="1000">
                            <Placeholder xs={12} className="card-img-top" style={{minHeight:"150px"}} />
                            <Card.Body>
                                <Card.Title><Placeholder xs={10} /></Card.Title>
                                <Button className='btn btn-info rounded my-3 w-50'><Placeholder xs={10} /></Button>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
                </Row>
                ) : (
                <Row className='row-cols-3 g-3 justify-content-center'>
                    {Clubs.map((sc,index)=>(
                    <Col md={3} key={index}>
                        <Card className='text-bg-info bg-info-subtle important-background shadow h-100' data-aos="flip-up" data-aos-duration="1000">
                        {appLanguage === 'hi' ? 
                            (
                                sc.scPhotoHi 
                                ? <Card.Img variant="top" src={sc.scPhotoHi} /> 
                                : sc.scPhoto
                                    ? <Card.Img variant="top" src={sc.scPhoto} />
                                    : <Placeholder xs={12} className="card-img-top" style={{minHeight:"150px"}} />
                            ) : (
                                sc.scPhoto
                                ? <Card.Img variant="top" src={sc.scPhoto} /> 
                                : <Placeholder xs={12} className="card-img-top" style={{minHeight:"150px"}} />
                            )
                        }
                            <Card.Body>
                                <Card.Title>{appLanguage === 'hi' ? (sc.sc_display_en === "1" ? sc.sc_name_hi || '' : sc.sc_name_hi || sc.sc_name) : sc.sc_name}</Card.Title>
                                <NavLink to={appLanguage === 'hi' ? `/क्लब-सोसायटी/विवरण/${sc.sc_htaccess_hi || sc.sc_htaccess}` : `/clubs-societies/details/${sc.sc_htaccess}`} className='btn btn-info rounded my-3' target='_blank' rel="noopener noreferrer">
                                    {t('ReadMore')}
                                </NavLink>
                                <Nav as="ul" className="d-flex justify-content-center" data-aos="flip-left" data-aos-duration="1500">
                                    <Nav.Item as="li">
                                        <Nav.Link href={sc.sc_facebook} target="_blank" rel="noopener noreferrer" className="social" style={{background:"#1877f2",color:"#FFF"}} aria-label={t('IGDTUW')+" - "+t('Facebook')+" "+t('Page')}>
                                            <i className="bi bi-facebook"></i>
                                            <span className="visually-hidden"> {t('externalLinkIndicator')}</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link href={sc.sc_instagram} target="_blank" rel="noopener noreferrer" className="social" style={{background:"#f77737",color:"#FFF"}} aria-label={t('IGDTUW')+" - "+t('Instagram')+" "+t('Page')}>
                                            <i className="bi bi-instagram"></i>
                                            <span className="visually-hidden"> {t('externalLinkIndicator')}</span>
                                        </Nav.Link>
                                    </Nav.Item>                            
                                    <Nav.Item as="li">
                                        <Nav.Link href="" target="_blank" rel="noopener noreferrer" className="social" style={{background:"#0a66c2",color:"#FFF"}} aria-label={t('IGDTUW')+" - "+t('Linkedin')+" "+t('Page')}>
                                            <i className="bi bi-linkedin"></i>
                                            <span className="visually-hidden"> {t('externalLinkIndicator')}</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link href="" target="_blank" rel="noopener noreferrer" className="social" style={{background:"#ff0000",color:"#FFF"}} aria-label={t('IGDTUW')+" - "+t('Youtube')+" "+t('Channel')}>
                                            <i className="bi bi-youtube"></i>
                                            <span className="visually-hidden"> {t('externalLinkIndicator')}</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Card.Body>
                        </Card>
                    </Col>
                    ))}
                </Row>
            )}
            </Card.Body>
        </Card>
    );
}
export default SocietyClubsList;